// Moved verbatim out of the original single-file App.tsx. Markup and classes are
// unchanged — the meeting tool is live and this restructure must not alter it.

export function Card({
  title,
  count,
  children,
}: {
  title: string;
  count: number | null;
  children: React.ReactNode;
}) {
  return (
    <div className="rounded-xl border border-edge bg-darker/80 p-5">
      <div className="mb-3 flex items-center gap-2">
        <h3 className="font-mono text-sm uppercase tracking-wider text-cyan">{title}</h3>
        {count !== null && (
          <span className="rounded-full bg-cyan/10 px-2 py-0.5 font-mono text-[0.7rem] text-cyan">
            {count}
          </span>
        )}
      </div>
      {children}
    </div>
  );
}

export function Empty({ text }: { text: string }) {
  return <p className="text-sm italic text-[#7a8493]">{text}</p>;
}
